// extracted by mini-css-extract-plugin
module.exports = {"root":"_3-1rg","slim":"_20gOM","content":"_2cMya","logoWrapper":"_2nqL_","logo":"_17zxy","contentWrapper":"_2W5SI","title":"_6qF7I","listItem":"_2KsvK"};